import { axios } from 'libs/axios';


export const logout = (): Promise<void> => {
  return axios.post(`auth/logout/`);
};
